import React from "react";
import { rgba } from "polished";
import styled, { css } from "styled-components";
import overlayAnimation from "../../../../animations/overlayAnimation";
import { slideInVertical } from "../../../../animations/slideIn";
import { slideOutVertical } from "../../../../animations/slideOut";
import { animationDuration, pageGutterSpace, zIndex } from "../../../../settings";
import breakpoint from "../../../../utils/breakpoint";
import getColor from "../../../../utils/getColor";
import space from "../../../../utils/space";
import { StyledSurfaceOrg } from "../../../organisms/SurfaceOrg/SurfaceOrg.styled";
import { breakpointValue } from "../ModalTemplate.settings";
var LoaderSvg = function LoaderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "0s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 20",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.165, 0.84, 0.44, 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "-0.9s",
    dur: "1.8s",
    values: "1; 0",
    calcMode: "spline",
    keyTimes: "0; 1",
    keySplines: "0.3, 0.61, 0.355, 1",
    repeatCount: "indefinite"
  }))));
};
LoaderSvg.defaultProps = {
  width: "44",
  height: "44",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor"
};
import { surfaceColorVariant, surfaceOrgBreakpointSpacingSpace, surfaceOrgSpacingSpace } from "./ModalOrg.settings";
var gutterExceptMobileSpace = pageGutterSpace;
var iconContainerBackground = "background";
var iconContainerSizeSpace = 22;
export var widthSpace = {
  "default": 85,
  narrow: 62
};
export var Overlay = styled.div.withConfig({
  componentId: "sc-1a2fszi-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;position:fixed;z-index:", ";top:0;right:0;bottom:0;left:0;align-items:center;justify-content:center;padding:", ";overflow:hidden;animation:", " ", "s forwards;"], zIndex.ModalOrg, space(gutterExceptMobileSpace), overlayAnimation(theme), animationDuration.slow / 1000);
});
export var Container = styled.div.withConfig({
  componentId: "sc-1a2fszi-1"
})(function (_ref2) {
  var $width = _ref2.$width,
    $isLoading = _ref2.$isLoading,
    $hasContent = _ref2.$hasContent,
    $hasAnimationOnClose = _ref2.$hasAnimationOnClose;
  return css(["width:100%;max-width:", ";animation:", " ", "s forwards;", "{display:flex;min-height:", ";max-height:calc(100vh - ", ");@supports (max-height:100dvh){max-height:calc(100dvh - ", ");}overflow:hidden;", "}", ""], space($hasContent ? widthSpace[$width] : iconContainerSizeSpace), slideInVertical(), animationDuration.slow / 1000, StyledSurfaceOrg, !$hasContent && space(iconContainerSizeSpace), space(2 * gutterExceptMobileSpace), space(2 * gutterExceptMobileSpace), $isLoading && css(["flex-direction:column;", "{flex-direction:row;}"], breakpoint(breakpointValue)), $hasAnimationOnClose && css(["animation:", " ", "s forwards;"], slideOutVertical, animationDuration.slow / 1000));
});
export var Header = styled.div.withConfig({
  componentId: "sc-1a2fszi-2"
})(function (_ref3) {
  var $hasNoTitle = _ref3.$hasNoTitle;
  return css(["", ""], $hasNoTitle && css(["display:flex;justify-content:flex-end;"]));
});
export var ContentWrapper = styled.div.withConfig({
  componentId: "sc-1a2fszi-3"
})(["display:flex;flex:1;flex-direction:column;overflow:hidden;"]);

/**
 * 1. Needed for isLoading state in horizontal view
 * */
export var Content = styled.div.withConfig({
  componentId: "sc-1a2fszi-4"
})(function (_ref4) {
  var $hasNoTitle = _ref4.$hasNoTitle,
    $isLoading = _ref4.$isLoading,
    theme = _ref4.theme;
  var background = getColor(theme, surfaceColorVariant);
  var gradient = "linear-gradient(".concat(background, " 25%, ").concat(rgba(background, 0.75), " 75%, ").concat(rgba(background, 0), ")");
  return css(["flex:1;padding-right:", ";padding-left:", ";overflow:auto;", "{padding-right:", ";padding-left:", ";}&:last-child{margin-bottom:0;}", ""], space(surfaceOrgSpacingSpace), space(surfaceOrgSpacingSpace), breakpoint(breakpointValue), space(surfaceOrgBreakpointSpacingSpace), space(surfaceOrgBreakpointSpacingSpace), !$isLoading && css(["&::before{content:\"\";display:block;position:sticky;top:0;height:", ";background:", ";", "{height:", ";}}&::after{content:\"\";display:block;position:sticky;bottom:0;height:", ";transform:rotate(180deg);background:", ";}"], space($hasNoTitle ? 1.5 : 3), gradient, breakpoint(breakpointValue), space($hasNoTitle ? 1 : 4), space(5), gradient));
});

/**
 * Needed to prevent display scrollbar when not necessary
 * */
export var ContentChildrenWrapper = styled.div.withConfig({
  componentId: "sc-1a2fszi-5"
})(["overflow:hidden;"]);
export var Buttons = styled.div.withConfig({
  componentId: "sc-1a2fszi-6"
})(["display:flex;justify-content:flex-end;padding:0 ", " ", ";", "{justify-content:center;padding:", ";}"], space(surfaceOrgBreakpointSpacingSpace), space(surfaceOrgBreakpointSpacingSpace), breakpoint("small", breakpointValue), space(surfaceOrgSpacingSpace));
export var IconContainer = styled.div.withConfig({
  componentId: "sc-1a2fszi-7"
})(function (_ref5) {
  var theme = _ref5.theme;
  return css(["display:flex;align-items:center;justify-content:center;padding:", ";background-color:", ";", "{min-height:", ";}", "{min-width:", ";padding:", ";}"], space(surfaceOrgSpacingSpace), getColor(theme, iconContainerBackground), breakpoint("small", breakpointValue), space(iconContainerSizeSpace), breakpoint(breakpointValue), space(iconContainerSizeSpace), space(surfaceOrgBreakpointSpacingSpace));
});
export var LoaderIcon = styled(LoaderSvg).withConfig({
  componentId: "sc-1a2fszi-8"
})(function (_ref6) {
  var theme = _ref6.theme;
  return css(["color:", ";"], getColor(theme, "secondary"));
});